import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FlipBackward = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 18 18" sx={{ height: '18px', width: '18px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M2.25 6.75H12.375C14.239 6.75 15.75 8.26104 15.75 10.125C15.75 11.989 14.239 13.5 12.375 13.5H9M2.25 6.75L5.25 3.75M2.25 6.75L5.25 9.75"
        stroke="#24B07E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default FlipBackward;
